export const addToDataLayer = (category, action, label, value, eventName) => {
    let dataLayer = window.dataLayer || [];

    dataLayer.push({
        event: eventName || 'Dynamic Event',
        eventCategory: category,
        eventAction: action,
        eventLabel: label,
        eventValue: value
    });
};
export const addGTMEvent = (eventName) => {
    addToDataLayer('GS', '', '', '', eventName);
}


/**
 *
 new_registration: freemium signup + HS premium signup + community signup + GM signup + SFG+ME signup
 new_freemium_registration: freemium signup
 new_hs_premium_registration: premium HS annual signup (not upgrade - meaning they immediately purchased it)
 new_hs_premium_monthly_registration: premium HS monthly signup (not upgrade - meaning they immediately purchased it)
 new_sfgme_premium_registration: premium SFG+ME signup (not upgrade - meaning they immediately purchased it)
 new_gm_premium_registration: premium GM signup (not upgrade - meaning they immediately purchased it)
 new_community_registration: community signup
 new_general_registration: registration for an account (without community, or freemium, or premium - does that even exist?
 */
export const addRegistrationEvent = (selectedPlan) => {
    let eventName = "new_general_registration";

    if (selectedPlan) {
        switch (selectedPlan) {
            case 'Freemium':
                eventName = 'new_freemium_registration';
                break;
            case 'Hortisketch':
                eventName = 'new_hs_premium_registration';
                break;
            case 'Hortisketch_Monthly':
                eventName = 'new_hs_premium_monthly_registration';
                break;
            case 'hortisketch_seeds_kit':
                eventName = 'new_sfgme_premium_registration';
                break;
            case 'Garden Manager':
                eventName = 'new_gm_premium_registration';
                break;
            case 'Community':
                eventName = 'new_community_registration';
                break;
        }
    }

    addGTMEvent('new_registration');
    addGTMEvent(eventName);
}
